import compose from 'recompose/compose';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { t } from '../../../../modules/infra/i18n';

import withValidatePassword from '../../../common/hoc/withValidatePassword';
import { changePassword } from '../../../auth/actions';

class ChangePassword extends Component {
  static propTypes = {
    changePassword: PropTypes.func.isRequired,
    validatePassword: PropTypes.func.isRequired,
    validatePasswordWarning: PropTypes.string.isRequired,
  };

  state = {
    oldPasswordError: '',
    newPasswordError: '',
    passwordChanged: false,
  };

  onSubmit = (e) => {
    e.preventDefault();

    const { currentPassword, newPassword, repeatedPassword } = this;
    this.setState({
      oldPasswordError: '',
      newPasswordError: '',
    });
    if (newPassword.value.length < 4) {
      this.setState({
        newPasswordError: t('settings:change_password.new_password_too_short'),
      });
    } else if (newPassword.value !== repeatedPassword.value) {
      this.setState({
        newPasswordError: t('settings:change_password.passwords_dont_match'),
      });
      newPassword.value = '';
      repeatedPassword.value = '';
    } else {
      const data = {
        oldPassword: currentPassword.value,
        newPassword: newPassword.value,
      };
      this.props
        .changePassword(data)
        .then(() =>
          this.setState({
            passwordChanged: true,
          })
        )
        .then(() => {
          currentPassword.value = '';
          newPassword.value = '';
          repeatedPassword.value = '';
        })
        .catch((error) => {
          this.setState({
            oldPasswordError: error.message,
          });
        });
    }
  };

  clearValidation = () => {
    this.setState({
      oldPasswordError: '',
      newPasswordError: '',
    });
  };

  render() {
    const { oldPasswordError, newPasswordError, passwordChanged } = this.state;
    const inputClassName = 'c-search__input c-input--white u-pl-';

    return (
      <div className="c-wrapper">
        <div className="u-max-width-710 u-margin-auto u-mv-">
          <div className="c-success-message u-mb" display-if={passwordChanged}>
            {t('settings:change_password.password_changed_successfully')}
          </div>
          <h4 className="u-pb--">{t('settings:change_password.title')}</h4>
          <div className="c-heading c-heading--small">
            <form onSubmit={this.onSubmit}>
              <div className="u-position-relative">
                <div className="u-1/2-medium-and-up">
                  <div className="c-label-new">{t('settings:change_password.current_password')}</div>
                  <input
                    ref={(input) => {
                      this.currentPassword = input;
                    }}
                    type="password"
                    className={classnames(inputClassName, { 'has-error': oldPasswordError })}
                    placeholder={t('settings:change_password.current_password_placeholder')}
                    name="currentPassword"
                    onClick={this.clearValidation}
                  />
                  {oldPasswordError ? <div className="c-input-error-message">{oldPasswordError}</div> : ''}
                </div>
              </div>
              <div className="u-position-relative">
                <div className="u-1/2-medium-and-up">
                  <div className="c-label-new u-mt">{t('settings:change_password.new_password')}</div>
                  <input
                    ref={(input) => {
                      this.newPassword = input;
                    }}
                    type="password"
                    className={inputClassName}
                    placeholder={t('settings:change_password.new_password_placeholder')}
                    name="newPassword"
                    onClick={this.clearValidation}
                    onChange={this.props.validatePassword}
                  />
                  <div className="u-font-color-red zeta" display-if={this.props.validatePasswordWarning}>
                    {this.props.validatePasswordWarning}
                  </div>
                  {newPasswordError ? <div className="c-input-error-message">{newPasswordError}</div> : ''}
                </div>
              </div>
              <div className="u-1/2-medium-and-up">
                <div className="c-label-new u-mt">{t('settings:change_password.repeat_new_password')}</div>
                <input
                  ref={(input) => {
                    this.repeatedPassword = input;
                  }}
                  type="password"
                  className={inputClassName}
                  placeholder={t('settings:change_password.repeat_new_password_placeholder')}
                  name="repeatedPassword"
                  onClick={this.clearValidation}
                />
              </div>
              <div className="o-flexbox u-pt">
                <div className="o-flexbox__item o-flexbox__item--flex-start">
                  <button type="submit" className="c-btn">
                    <span className="c-btn__text">{t('settings:change_password.change_password_button')}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  changePassword,
};

export default compose(connect(null, mapDispatchToProps), withValidatePassword)(ChangePassword);
